import { useContext } from 'react';
import { SyncConnectionContext, type SyncConnectionContextValue } from './SyncConnectionContext';

/**
 * useSyncConnection - Access global provider connection state
 *
 * Must be used within SyncConnectionProvider. Throws error if used outside provider.
 *
 * @returns Provider connection state and methods (state, connect, disconnect, abort)
 * @throws Error if used outside SyncConnectionProvider
 *
 * @example
 * const { state, connect } = useSyncConnection();
 * await connect('google-drive');
 */
export function useSyncConnection(): SyncConnectionContextValue {
  const context = useContext(SyncConnectionContext);
  if (!context) {
    throw new Error('useSyncConnection must be used within SyncConnectionProvider');
  }
  return context;
}
